// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"3f69b117","433":"91a8664d","453":"f1cfe16c"}[chunkId] + ".chunk.js";
};